import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cluster-sidebar-page-content" }
const _hoisted_2 = {
  key: 0,
  class: "frame card"
}
const _hoisted_3 = { class: "frame__overview" }
const _hoisted_4 = { class: "frame__header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_6 = { class: "frame__matched-card" }
const _hoisted_7 = { class: "frame other" }
const _hoisted_8 = { class: "frame__overview" }
const _hoisted_9 = { class: "frame__header" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_11 = { class: "n-page__statistics" }
const _hoisted_12 = { class: "cluster-events" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MatchedCardInfo = _resolveComponent("MatchedCardInfo")!
  const _component_Statistics = _resolveComponent("Statistics")!
  const _component_SortDropdown = _resolveComponent("SortDropdown")!
  const _component_ClusterEventItem = _resolveComponent("ClusterEventItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.clusterView.card)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('common.card', 'f')), 1),
            _hoisted_5
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_MatchedCardInfo, {
              id: _ctx.clusterView.card,
              "matched-lists": _ctx.clusterView.matched_lists,
              bestEventThumbnail: _ctx.clusterView.best_event.thumbnail,
              type: _ctx.cardType,
              "object-type": _ctx.objectType,
              confidence: _ctx.clusterView.match_confidence,
              corners: "rounded"
            }, null, 8, ["id", "matched-lists", "bestEventThumbnail", "type", "object-type", "confidence"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('common.cluster_events', 'f')), 1),
        _hoisted_10
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_Statistics, { module: _ctx.module }, null, 8, ["module"]),
        _createVNode(_component_SortDropdown, {
          items: _ctx.sortTypes,
          modelValue: _ctx.module.filter.current.ordering,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.module.filter.current.ordering) = $event))
        }, null, 8, ["items", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.module.items, (clusterEvent) => {
          return (_openBlock(), _createBlock(_component_ClusterEventItem, {
            key: clusterEvent.id,
            item: clusterEvent,
            "object-type": _ctx.objectType,
            onAction: _ctx.actionHandler
          }, null, 8, ["item", "object-type", "onAction"]))
        }), 128))
      ])
    ])
  ]))
}